import authReducer from '../reducers/authReducer';
import monitoredReducer from './monitorReducer';
import { combineReducers } from 'redux';
import dataReducer from './dataReducer';
import optionsRequestReducer from './optionsRequestReducer';

const allReducers = combineReducers({
  authData: authReducer,
  pagesData: dataReducer,
  monitor: monitoredReducer,
  options :optionsRequestReducer,
});

export default allReducers;
